<template>

    <v-app>

        <!-- Barra azul -->
        <v-app-bar app color="primary" dark>
            
            <v-toolbar-title>
                GESTÃO DE CHAMADOS v1.0.1
                <span v-if="loginStore.nomeFantasia"> - {{ loginStore.nomeFantasia }}</span>
            </v-toolbar-title>

            <v-spacer />

            <div>

                <!-- Botão de Notificações chamados abertos -->
                <v-menu
                    v-if="autorizacaoLogin.estaLogado && notificacoes.totalAbertos > 0"
                    offset-y
                    :close-on-content-click="false"
                >
                    <template v-slot:activator="{ props }">
                        <v-btn
                            icon
                            class="mr-2"
                            v-bind="props"
                        >
                            <v-badge :content="notificacoes.totalAbertos" color="red" overlap>
                                <v-icon size="28">mdi-bell-ring</v-icon>
                            </v-badge>
                        </v-btn>
                    </template>
                    
                    <v-card max-width="300">
                        
                        <v-card-title class="text-subtitle-1 py-2 bg-blue text-white text-center">Chamados Abertos</v-card-title>
                        
                        <v-divider></v-divider>
                        
                        <v-list dense>

                            <v-list-item
                                v-for="chamado in notificacoes.listaChamadosAbertos"
                                :key="chamado.id"
                                @click="abrirChamado(chamado.id)"
                            >
                                <v-list-item-title>{{ chamado.id }} - {{ chamado.nomeFantasia }}</v-list-item-title>
                            </v-list-item>
                            
                            <v-list-item v-if="notificacoes.listaChamadosAbertos.length === 0">
                                <v-list-item-title class="text-center">Nenhum chamado aberto</v-list-item-title>
                            </v-list-item>

                        </v-list>

                    </v-card>

                </v-menu>

                <!-- Botão de Notificações chamados pendentes clientes -->
                <v-menu
                    v-if="autorizacaoLogin.estaLogado && notificacoes.totalPendenteCliente > 0"
                    offset-y
                    :close-on-content-click="false"
                >
                    <template v-slot:activator="{ props }">
                        <v-btn
                            icon
                            class="mr-2"
                            v-bind="props"
                        >
                            <v-badge :content="notificacoes.totalPendenteCliente" color="red" overlap>
                                <v-icon size="28">mdi-account-clock-outline</v-icon>
                            </v-badge>
                        </v-btn>
                    </template>
                    
                    <v-card max-width="300">

                        <v-card-title class="text-subtitle-1 py-2 bg-blue text-white text-center">Pendentes Clientes</v-card-title>
                        
                        <v-divider></v-divider>
                        
                        <v-list dense>
                            <v-list-item
                                v-for="chamado in notificacoes.listaPendenteCliente"
                                :key="chamado.id"
                                @click="abrirChamado(chamado.id)"
                            >
                                <v-list-item-title>{{ chamado.id }} - {{ chamado.nomeFantasia }}</v-list-item-title>
                            </v-list-item>

                            <v-list-item v-if="notificacoes.listaPendenteCliente.length === 0">
                                <v-list-item-title class="text-center">Nenhum chamado pendente</v-list-item-title>
                            </v-list-item>

                        </v-list>

                    </v-card>

                </v-menu>
                
                <!-- Botão de Notificações comentários novos -->
                <v-menu
                    v-if="autorizacaoLogin.estaLogado && notificacoes.totalComentariosNovos > 0"
                    offset-y
                    :close-on-content-click="false"
                >
                    <template v-slot:activator="{ props }">
                        <v-btn
                            icon
                            class="mr-2"
                            v-bind="props"
                        >
                            <v-badge :content="notificacoes.totalComentariosNovos" color="red" overlap>
                                <v-icon size="28">mdi-note-edit</v-icon>
                            </v-badge>
                        </v-btn>
                    </template>
                    
                    <v-card max-width="300">

                        <v-card-title class="text-subtitle-1 py-2 bg-blue text-white text-center">Novos Comentários</v-card-title>
                        
                        <v-divider></v-divider>
                        
                        <v-list dense>
                            <v-list-item
                                v-for="chamado in notificacoes.listaComentariosNovos"
                                :key="chamado.id"
                                @click="abrirChamado(chamado.id)"
                            >
                                <v-list-item-title>{{ chamado.id }} - {{ chamado.nomeFantasia }}</v-list-item-title>
                            </v-list-item>

                            <v-list-item v-if="notificacoes.listaComentariosNovos.length === 0">
                                <v-list-item-title class="text-center">Nenhum novo comentário</v-list-item-title>
                            </v-list-item>

                        </v-list>

                    </v-card>

                </v-menu>

                <!-- Botão de Notificações chamados orçamentos aprovados -->
                <v-menu
                    v-if="autorizacaoLogin.estaLogado && notificacoes.totalOrcamentosAprovados > 0"
                    offset-y
                    :close-on-content-click="false"
                >
                    <template v-slot:activator="{ props }">
                        <v-btn
                            icon
                            class="mr-2"
                            v-bind="props"
                        >
                            <v-badge :content="notificacoes.totalOrcamentosAprovados" color="green" overlap>
                                <v-icon size="26">mdi-currency-usd</v-icon>
                            </v-badge>
                        </v-btn>
                    </template>
                    
                    <v-card max-width="300">

                        <v-card-title class="text-subtitle-1 py-2 bg-blue text-white text-center">Orçamentos Aprovados</v-card-title>

                        <v-divider></v-divider>
                        
                        <v-list dense>
                            <v-list-item
                                v-for="chamado in notificacoes.listaOrcamentosAprovados"
                                :key="chamado.id"
                                @click="abrirChamado(chamado.id)"
                            >
                                <v-list-item-title>{{ chamado.id }} - {{ chamado.nomeFantasia }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="notificacoes.listaOrcamentosAprovados.length === 0">
                                <v-list-item-title class="text-center">Nenhum orçamento aprovado</v-list-item-title>
                            </v-list-item>
                        </v-list>

                    </v-card>
                    
                </v-menu>
                
            </div>
                                
            <!-- Botão para alterar senha -->
            <v-btn 
                v-if="autorizacaoLogin.estaLogado"
                text 
                :title="`Alterar Senha Usuário: ${loginStore.nomeColaborador}`"
                @click="abrirAlteracaoSenha"
            >
                <v-icon left size="28">mdi-account</v-icon>                
            </v-btn>

            <v-btn 
                v-if="autorizacaoLogin.estaLogado"
                text 
                @click="sair"
                title="Sair do Sistema"
            >
                <v-icon left size="28">mdi-door-open</v-icon>                
            </v-btn>

        </v-app-bar>

        <!-- Menu lateral -->
        <v-navigation-drawer 
            app 
            :permanent="$vuetify.display.mdAndUp.value"
            :temporary="$vuetify.display.smAndDown.value"
            color="white"
            dark 
            :width="estadoBarraLateral ? 70 : 260"
            :rail="estadoBarraLateral"
            rail-width="70"
        > 
            <div class="navigation-content">
                
                <a target="_blank" class="estilo-link-site" href="https://suita.com.br">
                    <img class="logo-suita mt-4 mb-4" src="./assets/suitalogo.png" />
                </a>  

                <!-- Mostrar menu só se estiver logado ou com a tela expandida -->
                <div v-if="autorizacaoLogin.estaLogado" class="treeview-container">

                    <!-- Nó Raiz: Cadastros -->
                    <div class="tree-node">

                        <v-list-item 

                            v-if="loginStore.administrador === 1"
                            @click="alternarNos('cadastros')"
                            class="node-header"
                        >
                            <template #prepend>
                                <v-icon icon="mdi-folder" class="node-icon" />
                            </template>
                            
                            <v-list-item-title class="node-label">Cadastros</v-list-item-title>
                            
                            <template #append>                                
                                <v-icon 
                                    v-if="expandedNodes.cadastros" 
                                    icon="mdi-chevron-down" 
                                    size="small"
                                />
                                <v-icon 
                                    v-else 
                                    icon="mdi-chevron-right" 
                                    size="small"
                                />
                            </template>
                        </v-list-item>
                        
                        <v-expand-transition>

                            <div v-if="expandedNodes.cadastros" class="node-children">

                                <!-- Ramos Atividade -->
                                <v-list-item 
                                    :to="{ name: 'ListaRamosAtividade' }"
                                    class="tree-leaf"
                                    active-class="active-leaf"
                                    density="compact"
                                >                                    
                                    <template #prepend>
                                        <v-icon icon="mdi-briefcase" class="leaf-icon" />
                                    </template>
                                    <v-list-item-title>Ramos Atividade</v-list-item-title>
                                </v-list-item>
                                
                                <!-- Status Crédito -->
                                <v-list-item 
                                    :to="{ name: 'ListaStatusCredito' }"
                                    class="tree-leaf"
                                    active-class="active-leaf"
                                    density="compact"
                                >
                                    <template #prepend>
                                        <v-icon icon="mdi-credit-card" class="leaf-icon" />
                                    </template>
                                    <v-list-item-title>Status Crédito</v-list-item-title>
                                </v-list-item>
                                
                                <!-- Produtos -->
                                <v-list-item 
                                    v-if="loginStore.emissoraTelevisao === 0"
                                    :to="{ name: 'ListaProdutos' }"
                                    class="tree-leaf"
                                    active-class="active-leaf"
                                    density="compact"
                                >
                                    <template #prepend>
                                        <v-icon icon="mdi-package-variant" class="leaf-icon" />
                                    </template>
                                    <v-list-item-title>Produtos</v-list-item-title>
                                </v-list-item>
                                
                                <!-- Empresas -->
                                <v-list-item 
                                    :to="{ name: 'ListaEmpresas' }"
                                    class="tree-leaf"
                                    active-class="active-leaf"
                                    density="compact"
                                >
                                    <template #prepend>
                                        <v-icon icon="mdi-office-building" class="leaf-icon" />
                                    </template>
                                    <v-list-item-title>Empresas</v-list-item-title>
                                </v-list-item>
                                
                                <!-- Status Negociação -->
                                <v-list-item 
                                    v-if="loginStore.emissoraTelevisao === 0 && loginStore.administrador === 1"
                                    :to="{ name: 'ListaStatusNegociacao' }"
                                    class="tree-leaf"
                                    active-class="active-leaf"
                                    density="compact"
                                >                                    
                                    <template #prepend>
                                        <v-icon icon="mdi-handshake" class="leaf-icon" />
                                    </template>
                                    <v-list-item-title>Status Negociação</v-list-item-title>
                                </v-list-item>
                                
                                <!-- Tipos de Chamados -->
                                <v-list-item 
                                    :to="{ name: 'ListaTiposChamados' }"
                                    class="tree-leaf"
                                    active-class="active-leaf"
                                    density="compact"
                                >
                                    <template #prepend>
                                        <v-icon icon="mdi-ticket" class="leaf-icon" />
                                    </template>
                                    <v-list-item-title>Tipos Chamado</v-list-item-title>
                                </v-list-item>
                                
                                <!-- Cadastro Departamentos -->
                                <v-list-item 
                                    v-if="loginStore.emissoraTelevisao === 0"
                                    :to="{ name: 'ListaDepartamentos' }"
                                    class="tree-leaf"
                                    active-class="active-leaf"
                                    density="compact"
                                >
                                    <template #prepend>
                                        <v-icon icon="mdi-sale" class="leaf-icon" />
                                    </template>
                                    <v-list-item-title>Departamentos</v-list-item-title>
                                </v-list-item>
                
                                <!-- Cadastro Avarias -->
                                <v-list-item 
                                    v-if="loginStore.emissoraTelevisao === 1"
                                    :to="{ name: 'ListaAvarias' }"
                                    class="tree-leaf"
                                    active-class="active-leaf"
                                    density="compact"
                                >
                                    <template #prepend>
                                        <v-icon icon="mdi-hammer-wrench" class="leaf-icon" />
                                    </template>
                                    <v-list-item-title>Avarias</v-list-item-title>
                                </v-list-item>

                                <!-- Cadastro Fabricantes -->
                                <v-list-item 
                                    v-if="loginStore.emissoraTelevisao === 1"
                                    :to="{ name: 'ListaFabricantes' }"
                                    class="tree-leaf"
                                    active-class="active-leaf"
                                    density="compact"
                                >
                                    <template #prepend>
                                        <v-icon icon="mdi-factory" class="leaf-icon" />
                                    </template>
                                    <v-list-item-title>Fabricantes</v-list-item-title>
                                </v-list-item>

                                <!-- Cadastro tipos equipamentos -->
                                <v-list-item
                                    v-if="loginStore.emissoraTelevisao === 1" 
                                    :to="{ name: 'ListaTipoEquipamento' }"
                                    class="tree-leaf"
                                    active-class="active-leaf"
                                    density="compact"
                                >
                                    <template #prepend>
                                        <v-icon icon="mdi-chip" class="leaf-icon" />
                                    </template>
                                    <v-list-item-title>Tipos Equipamento</v-list-item-title>
                                </v-list-item>

                                <!-- E-mail -->
                                <v-list-item 
                                    :to="{ name: 'ListaEmail' }"
                                    class="tree-leaf"
                                    active-class="active-leaf"
                                    density="compact"
                                >
                                    <template #prepend>
                                        <v-icon icon="mdi-email" class="leaf-icon" />
                                    </template>
                                    <v-list-item-title>E-mail</v-list-item-title>
                                </v-list-item>

                                <!-- Cadastro Mensagens -->
                                <v-list-item 
                                    :to="{ name: 'ListaMensagens' }"
                                    class="tree-leaf"
                                    active-class="active-leaf"
                                    density="compact"
                                >
                                    <template #prepend>
                                        <v-icon icon="mdi-message-text" class="leaf-icon" />
                                    </template>
                                    <v-list-item-title>Mensagens</v-list-item-title>
                                </v-list-item>

                            </div>

                        </v-expand-transition>
                    </div>

                    <!-- Nó Raiz: Funções -->
                    <div class="tree-node">    

                        <v-list-item 
                            @click="alternarNos('funcoes')"
                            class="node-header"
                            :class="{ 'active-node': expandedNodes.funcoes }"
                        >
                            <template #prepend>
                                <v-icon icon="mdi-cog" class="node-icon" />
                            </template>
                            
                            <v-list-item-title class="node-label">Funções</v-list-item-title>
                            
                            <template #append>
                                <v-icon 
                                    v-if="expandedNodes.funcoes" 
                                    icon="mdi-chevron-down" 
                                    size="small"
                                />
                                <v-icon 
                                    v-else 
                                    icon="mdi-chevron-right" 
                                    size="small"
                                />
                            </template>

                        </v-list-item>
                        
                        <v-expand-transition>

                            <div v-if="expandedNodes.funcoes" class="node-children">
                                
                                <!-- Cadastro equipamentos -->
                                <v-list-item 
                                    v-if="loginStore.emissoraTelevisao === 1"
                                    :to="{ name: 'ListaEquipamentos' }"
                                    class="tree-leaf"
                                    active-class="active-leaf"
                                    density="compact"
                                >
                                    <template #prepend>
                                        <v-icon icon="mdi-chip" class="leaf-icon" />
                                    </template>
                                    <v-list-item-title>Equipamentos</v-list-item-title>
                                </v-list-item>

                                <!-- Liberação equipamentos-->
                                <v-list-item 
                                    v-if="(loginStore.liberador === 1 || loginStore.administrador === 1) && (loginStore.emissoraTelevisao == 1)"
                                    :to="{ name: 'LiberaEquipamentos' }"
                                    class="tree-leaf"
                                    active-class="active-leaf"
                                    density="compact"
                                >
                                    <template #prepend>
                                        <v-icon icon="mdi-message-text" class="leaf-icon" />
                                    </template>
                                    <v-list-item-title>Liberar/Devolver</v-list-item-title>
                                </v-list-item>
                                 
                                <!-- Chamados -->
                                <v-list-item
                                    
                                    v-if="loginStore.empresaManutencao === 1"
                                    :to="{ name: 'CadastroChamados' }"
                                    class="tree-leaf"
                                    active-class="active-leaf"
                                    density="compact"
                                >
                                    <template #prepend>
                                        <v-icon icon="mdi-phone" class="leaf-icon" />
                                    </template>
                                    <v-list-item-title>Chamados</v-list-item-title>

                                </v-list-item>

                                <v-list-item
                                    v-else
                                    :to="{ name: 'CadastroChamadosCliente' }"
                                    class="tree-leaf"
                                    active-class="active-leaf"
                                    density="compact"
                                >
                                    <template #prepend>
                                        <v-icon icon="mdi-phone" class="leaf-icon" />
                                    </template>
                                    <v-list-item-title>Chamados</v-list-item-title>

                                </v-list-item>  

                                <!-- Cadastro Negociações -->
                                <v-list-item 
                                    v-if="loginStore.emissoraTelevisao === 0"
                                    :to="{ name: 'CadastroNegociacoes' }"
                                    class="tree-leaf"
                                    active-class="active-leaf"
                                    density="compact"
                                >
                                    <template #prepend>
                                        <v-icon icon="mdi-message-text" class="leaf-icon" />
                                    </template>
                                    <v-list-item-title>Negociações</v-list-item-title>

                                </v-list-item>

                            </div>

                        </v-expand-transition>

                    </div>

                </div>

            </div>

            <!-- Botão para recolher/expandir -->
            <template v-slot:append>

                <v-divider></v-divider>
                
                <v-list-item
                    @click="alternarTamanhoBarra()"
                    class="rail-toggle-button"
                    :title="estadoBarraLateral ? 'Expandir menu' : 'Recolher menu'"
                    density="compact"
                >
                    <template v-slot:prepend>
                        <v-icon :icon="estadoBarraLateral ? 'mdi-chevron-right' : 'mdi-chevron-left'" />
                    </template>
                    
                </v-list-item>

            </template>

        </v-navigation-drawer>

        <!-- Conteúdo snackbar -->
        <v-main>
            <v-container fluid class="pa-4">
                <router-view />  
            </v-container>
            <AppSnackbar />      
        </v-main>

        <ModalErro />

        <!-- Modal Global -->
        <ModalAlteraSenha 
            v-model="modalSenhaAberto"
        />

    </v-app>
    
</template>

<script setup>

    // Importa módulos do Vue
    import { ref, onMounted, onUnmounted, reactive, watch } from 'vue'  
    
    // Importa o event bus
    import { emitter } from '../src/utils/eventBus'

    // Importa módulo do Vuetify
    import { useDisplay } from 'vuetify'

    // Importa módulos do Vue Router
    import { useRouter } from 'vue-router'
    
    // Importa axios para requisições HTTP
    import axios from 'axios';

    // Importa módulo que controla as autorizações se está logado ou não
    import { useAuthStore } from '@/stores/authStore'  // Para controle de login
    
    // Importa o serviço de notificações
    import notificacaoService from '@/services/notificacaoService'

    // Importa modal de erro
    import ModalErro from '@/components/ModalErro.vue'
    
    // Importa componente de Snackbar
    import AppSnackbar from '@/components/AppSnackbar.vue'
    
    // Importa modal de alteração de senha
    import  ModalAlteraSenha from '@/components/ModalAlterarSenha.vue'
    
    // Importa a store de erros
    import { useErroStore } from '@/stores/erroStore'
    
    // Importa a store de chamados
    import { useChamadoStore } from '@/stores/chamadoStore'

    // Carrega o endereço das api's
    const API_BASE_URL = import.meta.env.VITE_API_URL;

    // Importa a store de login
    import { useLoginStore } from '@/stores/loginStore'
    
    // Configura display
    const display = useDisplay()

    // Estado do drawer (menu lateral)
    const estadoBarraLateral = ref(false)

    // Cria a instância da store de login
    const loginStore = useLoginStore()

    // Importa a store de erros
    const erroStore = useErroStore()
    
    // Importa a store de autenticação
    const autorizacaoLogin = useAuthStore()

    // Importa o roteador
    const router = useRouter()
    
    // Importa a store de chamados
    const chamadoStore = useChamadoStore()

    // Cria variáveis reativas
    const modalSenhaAberto = ref(false)
    
    // Estado dos nós expandidos
    const expandedNodes = reactive({
        cadastros: false,
        funcoes: true
    })

    // Alternar modo rail (recolhido/expandido)
    const alternarTamanhoBarra = () => {
        
        // Alterna o estado
        estadoBarraLateral.value = !estadoBarraLateral.value
        
        // Expande o nó cadastros se estiver recolhido
        expandedNodes.cadastros = estadoBarraLateral.value

        // Salva o tamanho da barra lateral no localStorage
        localStorage.setItem('tamanhoBarraLaterar', estadoBarraLateral.value)
        
        // Emitir evento global
        emitter.emit('mudancaBarraLateral', estadoBarraLateral.value)
    }

    // Toggle para os nós do menu
    const alternarNos = (node) => {
        expandedNodes[node] = !expandedNodes[node]        
    }
    
    // Estado das notificações regulares
    const notificacoes = ref({
        
        totalAbertos: 0,
        listaChamadosAbertos: [],
        
        totalOrcamentosAprovados: 0,
        listaOrcamentosAprovados: [],
        
        totalComentariosNovos: 0,
        listaComentariosNovos: [],
        
        totalPendenteCliente: 0,
        listaPendenteCliente: [],

        ultimaAtualizacao: ''       
        
    });

    // Função para alterar senha
    const abrirAlteracaoSenha = () => {
        modalSenhaAberto.value = true
    }

    // Executa função para enceerrar sessão
    function sair() {

        // Desloga o usuário
        autorizacaoLogin.deslogar()
    }

    // Função para verificar largura da tela
    const handleResize = () => {

        // Se for mobile (sm e abaixo)
        if (display.smAndDown.value) {

            alternarTamanhoBarra()            
            
            // Expande o nó cadastros se estiver recolhido
            expandedNodes.cadastros = estadoBarraLateral.value      
        } 
        
        // Se for tablet/médio (md)
        else if (display.md.value) {

            // Recolhe automaticamente
            estadoBarraLateral.value = true 
            
            // Expande o nó cadastros se estiver recolhido
            expandedNodes.cadastros = estadoBarraLateral.value      
        } 
        
        // Se for desktop (lg e acima)
        else {

            // Expandido em telas grandes
            estadoBarraLateral.value = false 
                        
            // Expande o nó cadastros se estiver recolhido
            expandedNodes.cadastros = estadoBarraLateral.value      
        }
    }
    
    // Para mudanças automáticas também
    watch(estadoBarraLateral, (newValue) => {
        emitter.emit('mudancaBarraLateral', newValue)
    })

    // Executa ao montar o componente    
    onMounted(() => {

        // Verifica se está logado
        if (autorizacaoLogin.estaLogado) {

            // Adicionar listener para resize
            handleResize()
            window.addEventListener('resize', handleResize)

            // Se estiver logado em uma empresa de manutenção, ativa notificação de chamados
            if (loginStore.empresaManutencao === 1){

                notificacaoService.iniciarMonitoramento((chamadosAbertos, orcamentosAprovados, pendenteCliente, comentariosNovos) => {

                    // Atualiza as notificações com os dados recebidos do monitoramento
                    if (loginStore.empresaManutencao === 1) {
                    
                        notificacoes.value.totalAbertos = chamadosAbertos.length || 0;
                        notificacoes.value.listaChamadosAbertos = chamadosAbertos || [];

                        notificacoes.value.totalOrcamentosAprovados = orcamentosAprovados.length || 0;
                        notificacoes.value.listaOrcamentosAprovados = orcamentosAprovados || [];

                        notificacoes.value.totalPendenteCliente = pendenteCliente.length || 0;
                        notificacoes.value.listaPendenteCliente = pendenteCliente || [];

                        notificacoes.value.totalComentariosNovos = comentariosNovos.length || 0;
                        notificacoes.value.listaComentariosNovos = comentariosNovos || [];

                    } else {

                        notificacoes.value.totalAbertos = 0;
                        notificacoes.value.listaChamadosAbertos = [];

                        notificacoes.value.totalOrcamentosAprovados = 0;
                        notificacoes.value.listaOrcamentosAprovados = [];

                        notificacoes.value.totalComentariosNovos = 0;
                        notificacoes.value.listaComentariosNovos = [];

                        notificacoes.value.totalPendenteCliente = 0;
                        notificacoes.value.listaPendenteCliente = [];
                    }
                });
            }
        }
    });

    // Função chamada quando a janela é fechada
    onUnmounted(() => {
        
        window.removeEventListener('resize', handleResize)

        // Parar o watch se existir
        if (window.__stopLoginWatch) {
            window.__stopLoginWatch();
        }

        // Se estiver logado em uma empresa de manutenção, para monitoramento de chamados
        if (loginStore.empresaManutencao === 1){
            notificacaoService.pararMonitoramento();
        }
        
        // Limpar timers de sessão
        window.removeEventListener('beforeunload', this.handleBeforeUnload)
    });

    // Função para editar chamado pelo id
    const abrirChamado = (id) => {

        // Converte para número (ajuste conforme seu caso)
        const idNum = Number(id)
        
        // Remove de todas as listas
        notificacoes.value.listaChamadosAbertos = notificacoes.value.listaChamadosAbertos.filter(item => item.id !== idNum)
        notificacoes.value.totalAbertos = notificacoes.value.listaChamadosAbertos.length

        notificacoes.value.listaOrcamentosAprovados = notificacoes.value.listaOrcamentosAprovados.filter(item => item.id !== idNum)
        notificacoes.value.totalOrcamentosAprovados = notificacoes.value.listaOrcamentosAprovados.length

        notificacoes.value.listaComentariosNovos = notificacoes.value.listaComentariosNovos.filter(item => item.id !== idNum)
        notificacoes.value.totalComentariosNovos = notificacoes.value.listaComentariosNovos.length

        notificacoes.value.listaPendenteCliente = notificacoes.value.listaPendenteCliente.filter(item => item.id !== idNum)
        notificacoes.value.totalPendenteCliente = notificacoes.value.listaPendenteCliente.length

        // Navega para a página de cadastro de chamados com o id e ação de editar
        router.push({
            path: '/cadastro-chamados',
            query: { 
                id: id,
                acao: 'editar'
            }
        })
    }

    // Watch para monitorar mudanças no breakpoint
    watch(() => display.smAndDown.value, () => handleResize())
    watch(() => display.md.value, () => handleResize())
    watch(() => display.lgAndUp.value, () => handleResize())

</script>

<style scoped>

    /* REMOVE TODOS OS ESPAÇAMENTOS DO VUETIFY */
    .main-content {
        margin-top: 64px !important;
        padding: 0 !important;
        margin: 0 !important;
    }

    .main-content .v-main__wrap {
        padding: 0 !important;
        margin: 0 !important;
    }

    /* FORÇA REMOVER CONTAINERS INTERNOS */
    :deep(.container) {
        max-width: none !important;
        padding: 0 !important;
        margin: 0 !important;
    }

    :deep(.v-container) {
        max-width: none !important;
        padding: 0 !important;
        margin: 0 !important;
    }

    .navigation-content {
        padding: 0 10px;
    }

    .estilo-link-site {
        text-decoration: none;
        color: #fff;
        display: block;
        text-align: center;
    }
    
    /* Logo Suita Menu Lateral */
    .logo-suita {
        width: 90%;
        height: auto;
        display: block;
        margin: 0 auto;
    }

    /* Ajuste para garantir que o conteúdo não fique escondido */
    :deep(.v-navigation-drawer__content) {
        overflow-y: auto;
    }

    /* ESTILOS DO TREEVIEW INTEGRADOS */
    .treeview-container {
        font-family: 'Roboto', sans-serif;
        font-size: 13px;
        user-select: none;
        padding: 6px 0;
        margin-top: 10px;
    }

    .tree-node {
        margin-bottom: 5px;
    }

    /* Para diminuir apenas os itens filhos */
    .tree-leaf {
        font-size: 13px !important;
    }

    /* Para diminuir especificamente o texto dos v-list-item */
    .tree-leaf .v-list-item-title {
        font-size: 13px !important;
    }

    .node-header .v-list-item-title {
        font-size: 16px !important;
    }

    .node-header {
        cursor: pointer;
        border-radius: 4px;
        margin: 2px 8px;
        min-height: 40px;
        transition: all 0.2s ease;
    }

    .node-header:hover {
        background-color: rgba(25, 118, 210, 0.08);
    }

    .active-node {
        background-color: rgba(25, 118, 210, 0.12);
    }

    .node-label {
        font-weight: 600;
        color: #2c3e50;
        font-size: 0.9rem;
    }

    .node-icon {
        color: #6c757d;
        margin-right: 12px;
    }

    .node-children {
        margin-left: 16px;
        border-left: 2px solid #e0e0e0;
        padding-left: 8px;
    }

    .tree-leaf {
        min-height: 36px;
        margin: 1px 4px;
        border-radius: 4px;
        transition: all 0.2s ease;
    }

    .tree-leaf:hover {
        background-color: rgba(25, 118, 210, 0.04);
    }

    .tree-leaf.active-leaf {
        background-color: rgba(25, 118, 210, 0.1);
        color: #1976d2;
    }

    .tree-leaf.active-leaf .leaf-icon {
        color: #1976d2;
    }

    .leaf-icon {
        font-size: 18px;
        margin-right: 12px;
        color: #6c757d;
    }

    /* Ajustes para itens compactos */
    :deep(.v-list-item--density-compact) {
        min-height: 36px;
    }

    /* Remove o padding extra dos itens da lista */
    :deep(.v-list-item__prepend) {
        margin-right: -8px;
    }

    /* Estilos quando o drawer está recolhido (rail mode) */
    :deep(.v-navigation-drawer--rail) .navigation-content {
        padding: 0 8px;
    }

    :deep(.v-navigation-drawer--rail) .logo-suita {
        max-width: 50px;
        margin: 8px auto;
    }

    :deep(.v-navigation-drawer--rail) .node-label,
        :deep(.v-navigation-drawer--rail) .v-list-item-title:not(.node-label) {
        display: none;
    }

    :deep(.v-navigation-drawer--rail) .node-icon,
        :deep(.v-navigation-drawer--rail) .leaf-icon {
        margin-right: 0;
        justify-content: center;
    }

    :deep(.v-navigation-drawer--rail) .tree-leaf {
        justify-content: center;
        padding-left: 0 !important;
    }
    
    :deep(.v-navigation-drawer--rail) .node-header {
        justify-content: center;
    }

    /* Ajuste para itens ativos quando recolhido */
    :deep(.v-navigation-drawer--rail) .tree-leaf.v-list-item--active {
        background-color: rgba(25, 118, 210, 0.1);
        border-radius: 8px;
    }

</style>